import React from "react";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";

function Calendar({ events = [], renderEventContent }) {
  return (
    <FullCalendar
      eventContent={renderEventContent}
      events={events}
      buttonText={{ today: "Today" }}
      plugins={[dayGridPlugin]}
      initialView="dayGridMonth"
      dateClick={() => {}}
    />
  );
}

export default Calendar;
